import React from 'react';
import styled from 'styled-components';
import { FaGithub, FaGitlab, FaItchIo } from 'react-icons/fa';

const FooterContainer = styled.footer`
  background-color: #2d3436;
  color: #dfe6e9;
  padding: 2rem;
  margin-top: 3rem;
  text-align: center;
`;

const FooterContent = styled.div`
  max-width: 1200px;
  margin: 0 auto;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
`;

const SocialLinks = styled.div`
  display: flex;
  gap: 1.5rem;
  margin: 1rem 0;
`;

const SocialLink = styled.a`
  color: #74b9ff;
  font-size: 1.5rem;
  transition: color 0.2s;
  
  &:hover {
    color: #0984e3;
  }
`;

const Copyright = styled.p`
  font-size: 0.9rem;
  color: #b2bec3;
  margin: 0;
`;

const Footer: React.FC = () => {
  return (
    <FooterContainer>
      <FooterContent>
        <SocialLinks>
          <SocialLink href="https://github.com/armen138" target="_blank" rel="noopener noreferrer">
            <FaGithub />
          </SocialLink>
          <SocialLink href="https://gitlab.com/armen138" target="_blank" rel="noopener noreferrer">
            <FaGitlab />
          </SocialLink>
          <SocialLink href="https://armen138.itch.io" target="_blank" rel="noopener noreferrer">
            <FaItchIo />
          </SocialLink>
        </SocialLinks>
        <Copyright>
          © {new Date().getFullYear()} armen138.online - All games and content are the property of their respective creators
        </Copyright>
      </FooterContent>
    </FooterContainer>
  );
};

export default Footer; 